import { type MetadataOption } from "../../../types";

export type CheckboxState = {
  primary: string;
  indeterminate: boolean;
  checked: boolean;
};

export enum FilterModeOption {
  IS = "is",
  IS_NOT = "is not",
  STARTS_WITH = "starts with",
  ENDS_WITH = "ends with",
  CONTAINS = "contains",
  DOES_NOT_CONTAIN = "does not contain",
  MATCHES_REGEX = "matches regex",
  DOES_NOT_MATCHES_REGEX = "does not match regex",
}

export type FilterType = "regexp" | "values";

export type OnSave = (filterType: FilterModeOption, filtersOrRegex: string[] | string, inverse: boolean) => void;

export type FilterProps = {
  selected: MetadataOption;
  onSaveFilters: (filtersOrRegex: string[] | string) => void;
  touched?: Set<string>;
};
